// 语言切换的路径及展示文案的配置
const LanguageList = {
  ch: '中文',
  // kr: '한국어',
  en: 'En'
}

export default LanguageList